import { render, staticRenderFns } from "./editDictData.vue?vue&type=template&id=2051f564"
import script from "./editDictData.vue?vue&type=script&lang=js"
export * from "./editDictData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports